import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, V1 } from "@/lib/api";
import { School, FileText, Calendar, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function SchoolDashboard() {
  const { user } = useAuth();
  const [school, setSchool] = useState(null);
  const [apps, setApps] = useState([]);
  const [inv, setInv] = useState([]);
  const [exams, setExams] = useState([]);

  useEffect(() => {
    if (!user?.school_id) return;
    api.get(`${V1}/schools/${user.school_id}`).then((r) => setSchool(r.data));
    api.get(`${V1}/scholarship-applications/mine`).then((r) => setApps(r.data || []));
    api.get(`${V1}/invitations/mine`).then((r) => setInv(r.data || []));
    api.get(`${V1}/schools/${user.school_id}/scholarship-exams`).then((r) => setExams(r.data || []));
  }, [user]);

  return (
    <div className="space-y-6" data-testid="school-dashboard">
      <div>
        <div className="overline text-accent">Okul Paneli</div>
        <h1 className="font-display text-3xl font-bold">{school?.name || "Okulunuz"}</h1>
        <p className="text-muted-foreground mt-1">{school?.province} / {school?.district}</p>
      </div>
      <div className="grid md:grid-cols-4 gap-4">
        <Metric icon={FileText} label="Başvurular" value={apps.length} to="/okul-paneli/basvurular" />
        <Metric icon={Calendar} label="Aktif Sınav" value={exams.filter(e => e.status === "open").length} to="/okul-paneli/sinavlar" />
        <Metric icon={Mail} label="Gönderilen Davet" value={inv.length} to="/okul-paneli/davetler" />
        <Metric icon={School} label="Profil" value={school?.ai_generated_content ? "✔︎ Tamam" : "Yarım"} to="/okul-paneli/profil" />
      </div>

      <div className="rounded-xl border border-border bg-card p-6">
        <div className="font-display font-bold text-lg mb-4">Son Başvurular</div>
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-widest text-muted-foreground">
            <tr><th className="text-left pb-2">Başvuru</th><th className="text-left pb-2">Sınav</th><th className="text-left pb-2">Durum</th></tr>
          </thead>
          <tbody>
            {apps.length === 0 && <tr><td colSpan={3} className="p-4 text-muted-foreground">Henüz başvuru yok.</td></tr>}
            {apps.slice(0, 8).map((a) => (
              <tr key={a.id} className="border-t border-border">
                <td className="py-2 font-mono text-xs">{a.application_no}</td>
                <td className="py-2">{a.exam?.title}</td>
                <td className="py-2"><span className="px-2 py-0.5 bg-muted rounded text-xs uppercase">{a.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Metric = ({ icon: Icon, label, value, to }) => (
  <Link to={to} className="p-6 rounded-xl border border-border bg-card hover:border-primary/40" style={{ transition: "border-color 0.2s" }}>
    <Icon className="h-6 w-6 text-accent mb-3" />
    <div className="text-2xl font-display font-bold">{value}</div>
    <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{label}</div>
  </Link>
);
